import { useCompanyConfigContext } from "@/context/CompanyConfigContext";
import { Navigate } from "react-router-dom";
export const Shop = () => {
  const { company } = useCompanyConfigContext();

  if (company.features.giftCards) {
    return <Navigate to="/shop/giftCards" />;
  }
  if (company.features.zinc) {
    return <Navigate to="/shop/products" />;
  }
  if (company.features.travel) {
    return <Navigate to="/shop/travel" />;
  }
  throw new Error("No features enabled");
};
